@if (!hasData || (monitor?.status === monitorStatus.paused)) {
    <div class="agpr-viSummary-banner">
        <agpr-message [severity]="messageSeverities.info" [bottomMargin]="false">
            {{ 'VisibilityIntelligence.monitor.noData' | localize }}
        </agpr-message>
    </div>
}
<div class="agpr-viSummary">
    @for (summaryChart of summaryCharts; track summaryChart.exportID; let i = $index) {
        <div
            class="agpr-viSummary-container agpr-contextMenu-parent"
            #viTrendElement
        >
            <div class="agpr-viSummary-exportMenu agpr-contextMenu top right">
                <agpr-chart-export-menu
                    [id]="summaryChart.exportID"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                    (exportMenuClicked)="summaryTrendExport($event, viTrendElement, viSummaryChartTypeEnum.COVERAGE_OVER_TIME, summaryChart.header)"
                    [contextMenu]="true"
                    [social]="true"
                ></agpr-chart-export-menu>
            </div>
            <label class="agpr-viSummary-container-header">{{ summaryChart.header | localize }}</label>
            <span class="agpr-viSummary-container-message">{{ summaryChart.message | localize }}</span>
            <div class="agpr-viSummary-container-charts">
                <div class="agpr-viSummary-container-left" [ngClass]="summaryChart.cardBarChartHeightClass">
                    @if (summaryChart.cardChart) {
                            <agpr-reports-chart
                                [chart]="summaryChart.cardChart"
                                [disableViewMentionLink]="true"
                            ></agpr-reports-chart>
                        } @else {
                            <agpr-card-chart
                                class="agpr-viSummary-card--column"
                                [series]="summaryChart.cardSeries"
                                [color]="summaryChart.cardColor"
                                [layout]="cardChartLayoutTypes.vertical"
                                [bubbleTooltipSubjectLocalizationString]="summaryChart.cardBubbleTooltip"
                                [bubbleTooltipMetric]="summaryChart.chartType"
                                [headingLevel]="4"
                                [showNull]="true"
                                [numberOfDecimals]="summaryChart.decimalNumber"
                                [isPercentage]="percentageCharts.includes(summaryChart.chartType)"
                            ></agpr-card-chart>
                        }
                </div>
                <div class="agpr-viSummary-container-right" [agprLoading]="loading">
                    <agpr-am5-chart
                        [chart]="summaryChart.lineChart"
                        [series]="summaryChart.lineChartSeries"
                        (tooltipLinkClick)="openAm5ChartDrilldown($event)"
                    ></agpr-am5-chart>
                </div>
            </div>
        </div>
    }
</div>
